
const parseIntWithNull = value => (value === null ? 0 : parseInt(value, 10));
const parseFloatWithNull = value => (value === null ? 0 : parseFloat(value));


function parseTime(value) {
  // expecting value in format: T#{int}s. For example T#12s means 12s
  let result = parseIntWithNull(value);
  if (Number.isNaN(result)) {
    result = 0;
  }
  return result;
}

const variableTypesMapping = {
  BOOL: { in: value => Number(value) === 1, out: value => Number(value) },
  STRING: value => value,
  TIME: parseTime,
  INT: parseIntWithNull,
  SINT: parseIntWithNull,
  DINT: parseIntWithNull,
  USINT: parseIntWithNull,
  UINT: parseIntWithNull,
  UDINT: parseIntWithNull,
  REAL: parseFloatWithNull,
  LREAL: parseFloatWithNull,
  DATE: { in: value => new Date(parseIntWithNull(value * 1000)), out: value => value.getTime() / 1000 },
  DATE_AND_TIME: { in: value => new Date(parseIntWithNull(value * 1000)), out: value => value.getTime() / 1000 },
};

export function castInVariable(value, type) {
  const castingObj = variableTypesMapping[type];
  let func = castingObj;
  if (typeof castingObj === 'object') {
    func = castingObj.in;
  }
  if (!func) {
    func = v => v;
  }
  return func(value);
}

export function castOutVariable(value, type) {
  const castingObj = variableTypesMapping[type];
  let func = v => v;
  if (typeof castingObj === 'object') {
    func = castingObj.out;
  }
  return func(value);
}

export function prepareVariables(vars) {
  const newVars = {};
  const groups = {};
  Object.keys(vars).forEach((key) => {
    const varItem = vars[key];
    const newVarItem = { ...varItem };
    newVarItem.value = castInVariable(varItem.value, varItem.type);
    newVarItem.validation = varItem.validation;
    newVarItem.isWaiting = false;
    newVars[key] = newVarItem;
    if (newVarItem.aggregate === 'count') {
      if (groups[newVarItem.groupId] === undefined) {
        groups[newVarItem.groupId] = [];
      }
      groups[newVarItem.groupId].push(newVarItem.id);
    }
  });
  return { vars: newVars, groups };
}

export function prepareSceneVariables(vars) {
  const newVars = {};
  Object.keys(vars).forEach((key) => {
    const varItem = vars[key];
    const newVarItem = { ...varItem };
    newVarItem.value = castInVariable(varItem.value, varItem.type);
    newVarItem.validation = varItem.validation;
    newVarItem.isWaiting = false;
    newVars[key] = newVarItem;
  });
  return newVars;
}

export function isSceneVar(varItem) {
  return typeof varItem.sceneId !== 'undefined';
}

export const SERVICE_TYPES = {
  DEVICE: 'device',
  SERVICE: 'virtual_device',
  SCENE: 'scene',
};
